import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";

export default function InventorySubTable2(props) {
  const {
    data,
    loadingRows,
    rowDetails,
    selectedItems,
    setSelectedItems,
    openSlideForManufacturedItemDetails,
  } = props;

  const bodyProductName = (item) => {
    return (
      <div className="flex gap-2">
        {item.is_legacy === 1 ? <p className="text-lg my-auto">L</p> : null}
        <div>
          {item.product_name} <br />{" "}
          <span className="font-bold">PLU: {item.plu}</span>
        </div>
      </div>
    );
  };

  if (loadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.unique_id];
  if (!detail) return null;

  const subItemWeightData = (item) => {
    return (
      <p>
        {item.on_hand_net_kg} kg <br />
        {item.on_hand_net_lbs} lbs
      </p>
    );
  };

  const singleItemActionTemplate = (rowData) => {
    return (
      <div className="flex">
        <button
          className="ml-2 rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
          onClick={() => {
            openSlideForManufacturedItemDetails(rowData.id, rowData.pallet_id);
          }}
        >
          Info
        </button>
      </div>
    );
  };

  const subItemPiecesData = (item) => {
    return <p>{item.on_hand_piece_count} pieces</p>;
  };

  const totalCostData = (item) => {
    return <p>${item.production_total_cost}</p>;
  };

  const barcodeBody = (data) => {
    return (
      <div>
        <p>{data.barcode}</p>
      </div>
    );
  };

  const rowStyleClass = (data) => {
    return {
      "bg-cyan-100": data.pallet_id > 0,
      "bg-yellow-100": data.is_legacy === 1,
      "bg-gray-100": data.is_legacy === 0 && data.pallet_id < 1,
    };
  };

  const bodyCartonCount = (data) => {
    return <p>{data.total_cartons} cartons</p>;
  };

  return (
    <div>
      <DataTable
        value={rowDetails[data.unique_id]}
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm inventory-sub-items-two-table"
        cellClassName="py-2 border-1-bottom-gray px-2 text-sm"
        rowClassName={rowStyleClass}
        selectionMode="checkbox"
        selection={selectedItems}
        onSelectionChange={(e) => setSelectedItems(e.value)}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        <Column
          header="Product"
          body={bodyProductName}
          style={{ width: "20%" }}
        />
        <Column
          field="lot_number"
          header="Lot Number"
          style={{ width: "10%" }}
        />
        <Column header="Barcode" body={barcodeBody} style={{ width: "20%" }} />
        <Column
          header="Carton Count"
          body={bodyCartonCount}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          header="Weight"
          body={subItemWeightData}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          header="Piece count"
          body={subItemPiecesData}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          header="Total cost"
          body={totalCostData}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          field="warehouse_location_name"
          header="Location"
          style={{ width: "10%" }}
        />
        <Column body={singleItemActionTemplate} style={{ width: "19%" }} />
      </DataTable>
    </div>
  );
}
